import React, { useEffect } from "react";
import useCdpBopisModalConnector from "./use-cdp-bopis-modal-connector";

const CdpBopisModalConnector = ({
  trackCDPBopis,
  useBopisLocation,
  isBopisTabActive,
  setIsBopisTabActive,
  setIsBopisModalOpen
}) => {
  const shouldFetchInventory = false;

  const {
    getUserAddressError,
    getUserCityState,
    handleGetUserAddress,
    handleOnSelectStore,
    hasCookieError,
    isLoadingUserAddress,
    setGetUserAddressError,
    userLocation,
    selectedStore,
    isLoadingUserSearchQuery,
    nearbyBopisStores,
    nearbyStoresWithInventoryButNoBopis,
    getAddressFromSearchQuery,
    userSearchedLocation,
    userSearchedQuery,
    setUserSearchedLocation,
    searchQueryError,
    setSearchQueryError
  } = useBopisLocation({ shouldFetchInventory });

  const {
    activeStoreRadioBtn,
    setActiveStoreRadioBtn,
    shouldDisplayProductInfoHeader
  } = useCdpBopisModalConnector(selectedStore);

  const onCloseModal = () => {
    setIsBopisModalOpen(false);
    setUserSearchedLocation(null);
    setActiveStoreRadioBtn(null);
    setGetUserAddressError(null);
    setSearchQueryError(null);
  };

  const onSelectStoreClickHandler = async () => {
    handleOnSelectStore(activeStoreRadioBtn);

    if (!isBopisTabActive) {
      setIsBopisTabActive(true);
    }
    trackCDPBopis({ storeName: activeStoreRadioBtn.name }); // @BOPISCDPTODO - Is this analytics needed?
    onCloseModal();
  };

  //This component will be loaded only if isBopisModalOpen is true.
  useEffect(() => {
    if (!userLocation.city && !userLocation.address) {
      getUserCityState();
    }
  }, []);

  return (
    <>
      {/*Common BopisModalConnector will be called here once it´s migrated to v3*/}
    </>
  );
};

CdpBopisModalConnector.displayName = "CdpBopisModalConnector";
//TODO: This is exported withErrorBoundary from "@lululemon/mwa-common";
export default CdpBopisModalConnector;
